// ============================================
// モジュール読み込み
// ============================================
import { viewport } from './libs/switchViewport';
import { aboutLineScroll, careerImg, countUpNumber, headImg, inViewAnm, mvText, pageScroll } from './libs/Scroll';
import { drawer, fixedHeader, megaMenu } from './libs/Header';
import { addAutoFunc, confirmForm } from './libs/Form';
import { mv } from './libs/Mv';
import { storyHoverImg } from './libs/Hover';
import { imgLayout } from './libs/Img';
// import { accordionFunc } from './libs/Accordion';
// import { blogSort } from './libs/Blog';
// import { createIndex } from './libs/CreateIndex';
// import { articleTable, ScrollHintFunc } from './libs/ScrollHint';
// import { modal } from './libs/Modal';
// import { slider } from './libs/Slider';
// import { tabFunc } from './libs/Tab';

// 実行
// ==========================
window.addEventListener('DOMContentLoaded', () => {
  viewport();
  fixedHeader();
  drawer();
  megaMenu();
  // createIndex();
  addAutoFunc();
  confirmForm();
  pageScroll();
  mvText();
  aboutLineScroll();
  headImg();
  careerImg();
  storyHoverImg();
  countUpNumber();
  imgLayout();
  // accordionFunc();
  // articleTable();
  // ScrollHintFunc();
  // tabFunc();
});

window.addEventListener('load', () => {
  document.body.classList.add('is-loaded');
  document.querySelector('.c-hero')?.classList.add('is-active');
  inViewAnm();
  mv();
  // modal();
  // blogSort();
  // slider();
});
